import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";
import { CSSProperties } from "styled-components";

export const Container = styled("div")<{ scale: number }>`
	width: 368px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
	/* @media (max-width: 415px) {
		width: 95vw;
	} */
`;

export const Header = styled("div")<{ "data-image": string }>`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-image: url(${(props) => props["data-image"]});
	position: relative;
`;

export const HeaderTitle = styled("img")`
	object-fit: contain;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

export const PalmTrees = styled("div")<{ "data-image": string }>`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-image: url(${(props) => props["data-image"]});
	position: relative;
`;

export const Body = styled("div")`
	max-width: 372px;
	margin: 0 auto;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
`;

export const Title = styled("span")`
	max-width: 100%;
	font-family: "Inter";
	font-style: normal;
	font-size: 19px;
	text-align: center;
	font-weight: 800;
	line-height: 22px;
	color: #333;
	margin: 8px 0px;

	/* @media (max-height: 400px) {
		font-size: 22px;
	} */
`;

export const Button = styled(ThemeButton)`
	padding: 0.2rem;
	width: 90%;
	font-size: 16px;
`;

export const wrapperStyle: CSSProperties = {
	right: "auto"
};

export const bannerStyle: CSSProperties = {
	height: "2.2em",
	display: "flex",
	alignItems: "center"
};

export const textStyle: CSSProperties = {
	fontSize: "1.2em"
};
